// axios-init.js
import axios from 'axios'
import store from '@/store'
import { MessageBox,Message } from "element-ui"
import { getToken } from '@/utils/auth'

function serves(serve) {
    const service = axios.create({
        baseURL: serve,
        timeout: 60000000000000,
        headers: {
            common: { Authorization: 'Bearer ' + getToken() },
            applicationId: 18,
        }
    });
    service.interceptors.request.use(
        (config) => {
            config.headers.common.Authorization = 'Bearer ' + getToken()
            return config;
        },
        (error) => {
            return Promise.reject(error)
        }
    );
    service.interceptors.response.use(
        (response) => {
            const code = response.data.code || 200
            if (code === 401) {
                MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
                ).then(() => {
                    store.dispatch('LogOut').then(() => {
                        location.href = '/index';
                    }).catch(() => {
                        location.href = '/login';
                    })
                }).catch(() => {});
            } else if (code === 500) {
                Message({
                    message: response.data.msg,
                    type: 'error',
                    offset: 145,
                    showClose: true,
                })
                return Promise.reject(new Error(response.data.msg))
            } else if (code !== 200) {
                if (code == 40003) {
                    if (location.pathname != '/personalCenter') {
                        Message({
                            message: response.data.msg,
                            type: 'error',
                            offset: 145,
                            showClose: true,
                        })
                        location.href = '/personalCenter'
                    }
                    return
                }
                Message({
                    message: response.data.msg,
                    type: 'error',
                    offset: 145,
                    showClose: true,
                })
                return Promise.reject('error')
            } else {
                return response.data;
            }
        },
        (error) => {
            if (error.message.search(/40*/g) > -1) {
                // getToken()
            } else {
                try {
                    if (error.response.data.error.message) {
                        Message({
                            message: error.response.data.error.message,
                            type: 'error',
                            offset: 145,
                            showClose: true,
                        })
                    } else if (error.message) {
                        Message({
                            message: error.message,
                            type: 'error',
                            offset: 145,
                            showClose: true,
                        })
                    }
                } catch (error) {
                    return Promise.reject(error)
                }
            }
            return Promise.reject(error)
        }
    )
    return service
}

export default serves
